import { connect } from 'react-redux'
import freeDomains from 'free-email-domains'
import isEmail from 'validator/lib/isEmail'
import { isEmpty, password } from 'util/validation'
import { selectAccountIsOnboardingCompleted } from 'selectors/app'
import withFormFields from 'shared/ui/Form/withFormFields'

import { doSaveAndRedirect } from './actions'
import { doRedirectIfAuthenticated } from '../actions'
import EmailPageView from './view'

const isValidEmail = value => {
  if (isEmpty(value)) {
    return 'An email address is required'
  }
  if (
    !isEmail(value, {
      host_blacklist: freeDomains,
    })
  ) {
    return 'Please enter your work email address'
  }

  return null
}

const validators = {
  emailInput: isValidEmail,
  password,
}

const initialValues = {
  emailInput: '',
  password: '',
}

const select = state => ({
  initialValues,
  validators,
  isOnboardingComplete: selectAccountIsOnboardingCompleted(state),
})

const perform = {
  onSave: doSaveAndRedirect,
  redirectIfAuthenticated: doRedirectIfAuthenticated,
}

export default connect(select, perform)(withFormFields(EmailPageView))
